import { useDashboardActions } from "./useDashboardActions";

function useDashboardOperations() {
  const {} = useDashboardActions();

  return {};
}

export { useDashboardOperations };
